import {Record} from 'immutable';
import {ContentDetailId} from 'records/CoachingContentDetail';

export type CoachingContentDetailScoreId = number;

// TODO should rename view, this corresponds to both general skill based scores and scorecard scores
export default class CoachingContentDetailScore extends Record({
  id: null,
  contentDetail: null,
  contentDetailId: null,
  scorecardQuestionId: null,
  reviewFileuploadId: null,
  score: null,
  comment: null,
  reason: null,
}) {
  id?: CoachingContentDetailScoreId;
  contentDetail?: any; // TODO CoachingContentDetail
  contentDetailId: ContentDetailId;
  scorecardQuestionId?: number;
  reviewFileuploadId: number;
  score?: number;
  comment?: string;
  reason?: any;

  constructor(object: Partial<CoachingContentDetailScore> = {}) {
    super({
      ...object,
      contentDetailId: object.contentDetailId || (object.contentDetail && object.contentDetail.id),
    });
  }
}
